import { render, staticRenderFns } from "./AnalyteGuidelinesManagement.vue?vue&type=template&id=2755f1bc&scoped=true"
import script from "./AnalyteGuidelinesManagement.vue?vue&type=script&lang=js"
export * from "./AnalyteGuidelinesManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2755f1bc",
  null
  
)

export default component.exports